import { useState } from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../../Util/DeleteConfirmationDialog";

const DeleteCobrandTagModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  cobrandTag,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `internal/cobrand/cobrand-tag/${cobrandTag?.cobrandTagId}/`,
    },
    { manual: true }
  );

  const handleDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      setErrorMessage(
        apiMessage ||
          "Unable to delete this cobrand tag. Please ensure it is not in use and try again."
      );
    }

    return false;
  };

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={handleDelete}
      resourceName={cobrandTag?.name}
      resourceType="cobrand tag"
      confirmationValue={cobrandTag?.name || "delete"}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteCobrandTagModal;
